export default __webpack_public_path__ + "static/media/erika_provider.a53700c0.png";